import type { BadgeProps } from '@/components/ui'

type BadgeVariant = NonNullable<BadgeProps['variant']>

export type ChannelStatusLabelKey =
  | 'channels.status.connected'
  | 'channels.status.waiting'
  | 'channels.status.disconnected'
  | 'channels.status.failed'

/**
 * Traduz o `ChannelStatus` cru do backend para o vocabulario de produto (docs/design/00 s5): nunca
 * expor "instancia"/"inbox"/provider. `Created` e `WaitingForPairing` viram ambos "Aguardando
 * conexao" — para o usuario, o canal ainda nao esta no ar. Status desconhecido (valor futuro do
 * backend) cai em "Aguardando conexao", nunca inventa um rotulo.
 */
export function channelStatusLabelKey(status: string): ChannelStatusLabelKey {
  switch (status) {
    case 'Connected':
      return 'channels.status.connected'
    case 'Disconnected':
      return 'channels.status.disconnected'
    case 'Failed':
      return 'channels.status.failed'
    default:
      return 'channels.status.waiting'
  }
}

export function channelStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'Connected':
      return 'success'
    case 'WaitingForPairing':
    case 'Disconnected':
      return 'warning'
    case 'Failed':
      return 'danger'
    default:
      return 'neutral'
  }
}

/** Canal no ar (recebendo conversas). */
export function isChannelConnected(status: string): boolean {
  return status === 'Connected'
}

/**
 * Estados de transicao em que ainda vale acompanhar a lista por poll: o canal foi criado mas ainda
 * nao pareou. `Disconnected`/`Failed` sao estaveis ate o usuario reconectar (acao explicita).
 */
export function isChannelConnecting(status: string): boolean {
  return status === 'Created' || status === 'WaitingForPairing'
}
